export const REQUEST = (actionTypeName) => `${actionTypeName}_REQ`;
export const SUCCESS = (actionTypeName) => `${actionTypeName}_RESP`;
export const ERROR = (actionTypeName) => `${actionTypeName}_ERR`;
export const CLEAR = (actionTypeName) => `${actionTypeName}_CLEAR`;
export const SET = (actionTypeName) => `${actionTypeName}_SET`;
